/**
 * Statutory Israeli alcohol regulation warning.
 *
 * Mandated wording: any deviation from the literal text below — or removal
 * of the data-regulation="alcohol-warning" attribute — breaks compliance.
 * The regulation.alcohol_warning_present health check reads this file
 * directly and asserts both strings are present verbatim.
 *
 * Rendered in two places:
 *   - Footer of every page (SiteLayout)
 *   - Below the product details on each wine page (Product)
 */

export const ALCOHOL_WARNING_TEXT =
  "אזהרה: צריכה מופרזת של אלכוהול מסכנת חיים ומזיקה לבריאות!";

/** Stable DOM attribute used by automated regression checks. */
export const ALCOHOL_WARNING_SELECTOR_NAME = "data-regulation";
export const ALCOHOL_WARNING_SELECTOR_VALUE = "alcohol-warning";

export function AlcoholWarning() {
  return (
    <div
      data-regulation={ALCOHOL_WARNING_SELECTOR_VALUE}
      role="note"
      aria-label="אזהרה רגולטורית"
      className="mx-auto max-w-3xl text-center font-extrabold text-black bg-white"
      style={{
        borderColor: "#000",
        borderStyle: "solid",
        borderWidth: "3px",
        fontSize: "clamp(18px, 2.6vw, 26px)",
        lineHeight: 1.15,
        letterSpacing: "0.01em",
        padding: "0.5em 0.75em",
      }}
    >
      {ALCOHOL_WARNING_TEXT}
    </div>
  );
}
